import { ridSegment } from '@krp/client-runtime'

/** Адреса чеков базы 1С (RP-FB12): кассы ККМ, чеки за период и чек целиком. Литерал `/api/` законен только здесь. */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}/receipts`

/** Метка «Обновить» в адресе: служба читает 1С заново, а ответ получает новый ключ кэша браузера. */
const withFresh = (query: URLSearchParams, fresh: number | undefined): URLSearchParams => {
  if (fresh !== undefined && fresh > 0) query.set('fresh', String(fresh))
  return query
}

export const ONEC_RECEIPTS_URLS = {
  registers: (resourceId: string, fresh?: number) => {
    const query = withFresh(new URLSearchParams(), fresh).toString()
    return `${base(resourceId)}/registers${query === '' ? '' : `?${query}`}`
  },
  /** Первый и последний день, за который в базе есть чеки. */
  bounds: (resourceId: string, fresh?: number) => {
    const query = withFresh(new URLSearchParams(), fresh).toString()
    return `${base(resourceId)}/bounds${query === '' ? '' : `?${query}`}`
  },
  /** Кассы узла дерева — `registerKey` повторяется; пусто — все кассы базы. */
  list: (resourceId: string, from: string, to: string, registerKeys: readonly string[], fresh?: number) => {
    const query = withFresh(new URLSearchParams({ from, to }), fresh)
    for (const key of registerKeys) query.append('registerKey', key)
    return `${base(resourceId)}?${query.toString()}`
  },
  /** Статистика за период: срезы «день · касса · кассир · вид», без самих чеков. */
  summary: (resourceId: string, from: string, to: string, fresh?: number) => `${base(resourceId)}/summary?${withFresh(new URLSearchParams({ from, to }), fresh).toString()}`,
  receipt: (resourceId: string, kind: string, key: string) => `${base(resourceId)}/${kind}/${encodeURIComponent(key)}`,
} as const
